import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import dayjs from "dayjs";

// language
let locale =
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;

locale = locale.includes("-") ? locale.split("-")[0] : locale;

const languages = ["en", "tr", "fr"];

if (!window.localStorage.getItem("lang")) {
  window.localStorage.setItem(
    "lang",
    languages.includes(locale) ? locale : "en"
  );
}
const currentLang = window.localStorage.getItem("lang");

import "dayjs/locale/tr";
import "dayjs/locale/en";

if (currentLang === "tr") {
  dayjs.locale("tr");
} else {
  dayjs.locale("en");
}

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import ElementPlusLangTr from "element-plus/es/locale/lang/tr";
import ElementPlusLangEng from "element-plus/es/locale/lang/en";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import Amplify from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);

import "@/core/plugins/prismjs";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: currentLang == "tr" ? ElementPlusLangTr : ElementPlusLangEng,
});

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
